import { BrowserRouter as Router } from 'react-router-dom';
import { CandidateConsentRoutes } from './Route';

export const CandidateConsentApp = () => (
  <Router>
    <CandidateConsentRoutes />
  </Router>
);
